module.exports = __webpack_public_path__ + "static/sponsor-05-713eead6b0c28c18be62282012906829.png";